<script lang="ts">
    import { onMount } from "svelte"
    import AnimatingMoreArrow from "../../widgets/AnimatingMoreArrow.svelte"
    import { animateOnVisible } from "../../../configs/config"
    let { animate }: { animate?: boolean } = $props()
    let headings: Array<{ id: string; text: string; element: HTMLElement }> = $state([])
    let ulEl: HTMLElement | null = $state(null)
    onMount(() => {
        const elements = document.querySelectorAll("h2[id^='row-']")
        headings = Array.from(elements)
            .map((el) => ({
                id: el.id,
                text: el.textContent ?? "",
                element: el as HTMLElement,
            }))
            .filter((h) => h.text.trim().length > 0)

        const aEls = ulEl?.querySelectorAll("a")
        if (animate)
            animateOnVisible(aEls, {
                translateX: ["-30px", "0rem"],
                delay: (_, i) => i * 50,
                duration: 300,
                opacity: [0, 1],
                easing: "cubicBezier",
            })
    })

    function scrollToHeading(heading: { id: string; text: string; element: HTMLElement }) {
        heading.element.scrollIntoView({ behavior: "smooth", block: "center" })
    }
    let active = $state(-1)
</script>

<ul bind:this={ulEl}>
    {#each headings as heading, idx (heading.id)}
        <li>
            <a
                onmouseenter={() => (active = idx)}
                onmouseleave={() => (active = -1)}
                href={"#" + heading.id}
                onclick={(e) => {
                    e.preventDefault()
                    scrollToHeading(heading)
                }}
            >
                <span>
                    <AnimatingMoreArrow active={active == idx} height={24} />
                </span>
                <span>{heading.text}</span>
            </a>
        </li>
    {/each}
</ul>

<style lang="less">
    ul {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        list-style: none;
        padding: 0;
        li {
            a {
                display: flex;
                align-items: flex-start;
                gap: 0.6rem;
                text-decoration: none;
                color: inherit;
                cursor: pointer;
                padding: 0.3rem;
                transition:
                    background-color 0.2s ease,
                    padding 0.2s ease,
                    color 0.2s ease;

                &:hover {
                    color: var(--brand-100);
                    padding-left: 0.6rem;
                }
                span {
                    display: flex;
                    align-items: center;
                    gap: 0.6rem;
                }
            }
        }
    }
</style>
